<template>
  <div>
    <HeaderBlock :block="entry.headerBlock" />
    <ContentBlocks :entry="entry" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import HeaderBlock, { HeaderBlockFragment } from '@/components/common/headerBlock/HeaderBlock';

export const ShopPageFragment = gql`
  fragment ShopPageFragment on shopPage_Entry {
    title
    uri
    headerBlock {
      ...HeaderBlockFragment
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }

  ${ContentBlocksMatrixFragment}
  ${HeaderBlockFragment}
`;

export default defineNuxtComponent({
  name: 'ShopPage',
  components: { ContentBlocks, HeaderBlock },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
  },
});
</script>
